import React, {useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import * as api from "../../../../apis/platforms/admin/placingInstruments"
import useAntTable from "../../../../utils/useAntTable";
import {Button, Divider, message, Space, Tag} from "antd";
import {Link, useHistory} from "react-router-dom";
import {useRequest} from "ahooks";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import withAuth from "../../../../utils/withAuth";
import UploadModal from "../../../../components/UploadModal";
import {exportPlacingInstruments} from "../../../../apis/platforms/admin/placingInstruments";

const AddButton = withAuth('add', Button)
const ImportButton = withAuth('import', Button)
const ExportButton = withAuth('export', Button)

export default function PlacingInstruments() {

    const history = useHistory()
    const {refresh, tableProps, form, search, download, downloading} = useAntTable(api.getPlacingInstruments, {
        downloadUrl: api.exportPlacingInstruments
    })
    const [uploadModalVisible, setUploadModalVisible] = useState(false)

    const {
        run: doImportPlacingInstruments,
        loading: doImportPlacingInstrumentsLoading
    } = useRequest(api.importPlacingInstruments, {
        manual: true,
        onSuccess: () => {
            setUploadModalVisible(false)
            refresh()
        }
    })

    const {run: switchStatus} = useRequest(api.switchStatus, {
        manual: true,
        onSuccess: () => {
            message.success("操作成功")
            refresh()
        }
    })

    const columns = [
        {
            title: '医院名称',
            dataIndex: 'hospitalName'
        },
        {
            title: '客户名称',
            dataIndex: 'dealerName'
        },
        {
            title: '医院仪器全称',
            width: 400,
            dataIndex: 'hospitalInstrumentsFullName'
        },
        {
            title: '仪器型号-有效期',
            dataIndex: 'specificationAndModel'
        },
        {
            title: '是否条形码产品',
            width: 150,
            dataIndex: 'barcode',
            render(value: boolean) {
                return value ? <Tag color={"green"}>是</Tag> : <Tag color={"red"}>否</Tag>
            }
        },
        {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            render(value: boolean) {
                return value ? <Tag color={"green"}>已启用</Tag> : <Tag color={"red"}>已停用</Tag>
            }
        },
        {
            title: '操作',
            width: 150,
            dataIndex: 'operations',
            render: (_: any, record: any) => (
                <span>
                    {!record.fixed && (
                        <>
                            <Link to={`/product/placingInstruments/detailPage/${record.id}`}>详情</Link>
                            <Divider type={"vertical"}/>
                            <a onClick={() => switchStatus(record.id)}>{record.status ? '停用' : '启用'}</a>
                        </>
                    )}
                </span>
            )
        }
    ]

    const extSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'hospital',
            title: '医院名称',
            search: {
                colSpan: 6
            }
        },
        {
            dataIndex: 'dealer',
            title: '客户名称或编号',
            search: {
                colSpan: 6
            }
        },
        {
            dataIndex: 'specificationAndModel',
            title: '规格型号',
            search: {
                colSpan: 6
            }
        },
        {
            dataIndex: 'barcode',
            title: '条形码',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: true, text: '是'},
                    {value: false, text: '不是'},
                ],
                colSpan: 6
            }
        }
    ];

    return (
        <PageHeaderLayout>
            <StandardTable columns={columns} {...tableProps} form={form} search={search}
                           extSearchColumns={extSearchColumns} toolbar={
                <Space>
                    <AddButton type={'primary'}
                               onClick={() => history.push(`/product/placingInstruments/addPage`)}>新增</AddButton>

                    <ImportButton type={'primary'} onClick={() => setUploadModalVisible(true)}>导入</ImportButton>
                    <ExportButton type={'primary'} onClick={() => download()} loading={downloading}>导出</ExportButton>
                </Space>
            }/>
            <UploadModal onUpload={doImportPlacingInstruments}
                         open={uploadModalVisible}
                         title={'导入投放仪器'}
                         template={'/template/投放仪器导入模板.xlsx'}
                         confirmLoading={doImportPlacingInstrumentsLoading}
                         onCancel={() => setUploadModalVisible(false)}/>
        </PageHeaderLayout>
    )
}
